export const GIFT_STATES = {
  PROMPT: 'prompt_send_bogo_gift',
  SEND: 'send_bogo_gift',
  SENT: 'gift_sent',
  FINISH: 'finish',
}

export const GIFT_TRANSITIONS = {
  CHOOSE_WHEN: 'choose_when_send_gift',
  SCHEDULE_NOW: 'bogo_schedule_now',
  SCHEDULE_LATER: 'bogo_schedule_later',
  GIFT_SENT: 'bogo_gift_sent',
  EXIT: 'exit',
}

export const GIFT_MACHINE_ID = 'bogo_send_gift'
